import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import { ModuleFE_PermissionUser } from '../../_entity.js';
import { Page_ItemsEditor } from '@nu-art/thunderstorm-frontend/components/Page_ItemsEditor/index';
import { ModuleFE_Toaster, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { MultiSelect } from '../ui-props.js';
import { Component_BasePermissionItemEditor } from './editor-base.js';
import { TS_EditableItemControllerProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { sortArray, StaticLogger } from '@nu-art/ts-common';
import { PermissionKeyFE_AccountManagementAdmin } from '../../core/permission-keys.js';
import { AccessLevel } from '../../modules/ModuleFE_PermissionsAssert.js';
class Component_EditAccount extends Component_BasePermissionItemEditor {
    static defaultProps = {
        module: ModuleFE_PermissionUser,
        displayResolver: (item) => ModuleFE_Account.cache.unique(item._id)?.email ?? 'Not Found'
    };
    editorContent = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Groups', children: _jsx(MultiSelect.Group, { className: 'user-permission-groups', editable: this.state.editable, prop: 'groups' }) });
    };
}
class Controller_EditAccount extends TS_EditableItemControllerProto {
    static defaultProps = {
        keys: ['selected'],
        module: ModuleFE_PermissionUser,
        editor: Component_EditAccount,
        createInitialInstance: () => ({}),
        autoSave: true
    };
}
export class PermissionUsersEditor extends Page_ItemsEditor {
    //######################### Static #########################
    static Route = {
        key: 'user-permission-editor',
        path: 'user-permission-editor',
        Component: this
    };
    renderHeader() {
        return _jsx(_Fragment, { children: "User Permissions" });
    }
    static defaultProps = {
        keys: ['selected'],
        module: ModuleFE_PermissionUser,
        mapper: (user) => [ModuleFE_Account.cache.unique(user._id)?.email ?? 'Not Found'],
        sort: (items) => sortArray(items, (user) => ModuleFE_Account.cache.unique(user._id)?.email),
        itemRenderer: (user) => _jsx(_Fragment, { children: ModuleFE_Account.cache.unique(user._id)?.email ?? 'Not Found' }),
        EditorRenderer: Controller_EditAccount,
        hideAddItem: true,
        route: this.Route,
        contextMenuActions: [
            {
                label: 'Delete Account',
                action: async (item) => {
                    if (PermissionKeyFE_AccountManagementAdmin.getAccessLevel() !== AccessLevel.HasAccess) {
                        ModuleFE_Toaster.toastError('No permissions to delete account!');
                        return true;
                    }
                    try {
                        const accountId = item._id;
                        await ModuleFE_Account._v1.deleteAccount({ accountId }).executeSync();
                        return true;
                    }
                    catch (err) {
                        StaticLogger.logError(err);
                        ModuleFE_Toaster.toastError(err.errorResponse.debugMessage.split('\n')[0]);
                    }
                }
            }
        ]
    };
}
//# sourceMappingURL=permission-users-editor.js.map